// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === 615 ? "home" : chunkId) + "." + {615: "e77e217e64ee372a",655: "2779ca6a964b3e1a",}[chunkId] + ".js"
}